(function () {
  // The carousel runs on mobile only; on desktop (>= 990px) it is destroyed so
  // the grid layout stays exactly as it was. On mobile it shows a fractional
  // number of cards so part of the next one peeks in.
  const MOBILE_QUERY = "(max-width: 989.98px)";

  const initCarousel = (carouselEl) => {
    if (typeof Swiper === "undefined" || !carouselEl || carouselEl.swiper)
      return;

    // eslint-disable-next-line no-undef
    new Swiper(carouselEl, {
      slidesPerView: 1.5,
      spaceBetween: 8,
      watchOverflow: true,
      grabCursor: true,
      simulateTouch: true,
      allowTouchMove: true,
      watchSlidesProgress: true,
      preventInteractionOnTransition: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: carouselEl.querySelector(".products-grid__button-next"),
        prevEl: carouselEl.querySelector(".products-grid__button-prev"),
      },
      breakpoints: {
        576: { slidesPerView: 2.5 },
      },
    });
  };

  const destroyCarousel = (carouselEl) => {
    if (carouselEl && carouselEl.swiper) carouselEl.swiper.destroy(true, true);
  };

  const syncCarousel = (section) => {
    const carouselEl = section.querySelector(".swiper--products-grid");
    if (!carouselEl) return;

    if (window.matchMedia(MOBILE_QUERY).matches) {
      initCarousel(carouselEl);
    } else {
      destroyCarousel(carouselEl);
    }
  };

  const setupCarousel = (section) => {
    if (!section.querySelector(".swiper--products-grid")) return;

    syncCarousel(section);

    const resizeObserver = new ResizeObserver(() => syncCarousel(section));
    resizeObserver.observe(section);
  };

  async function handleResponse(response, section) {
    const responseText = await response.text();
    const html = document.createElement("div");
    html.innerHTML = responseText;

    const sourceGrid = html.querySelector(".products-grid--search-perfomed");
    const targetWrapper = section.querySelector(".products-grid");

    if (!sourceGrid || !targetWrapper) {
      section.classList.add("products-grid-section--empty");
      return;
    }

    targetWrapper.innerHTML = sourceGrid.innerHTML;
  }

  const initSection = async (section) => {
    if (!section || !section.classList.contains("products-grid-section"))
      return;

    const box = section.querySelector(".products-grid");
    if (!box) return;

    const isDynamicLoad = box.dataset.isDynamicLoad === "true";
    const collectionUrl = box.dataset.collectionUrl;
    const loadingEl = box.querySelector(".loading-overlay");

    if (isDynamicLoad && collectionUrl && collectionUrl !== "none") {
      box.classList.add("products-grid--loading");

      try {
        const response = await fetch(collectionUrl);
        await handleResponse(response, section);
        try {
          colorSwatches();
        } catch (err) {}
      } catch (error) {
        console.error("Error when fetching products:", error);
        section.classList.add("products-grid-section--empty");
      } finally {
        box.classList.remove("products-grid--loading");
        if (loadingEl) loadingEl.remove();
      }
    } else {
      box.classList.remove("products-grid--loading");
      if (loadingEl) loadingEl.remove();
    }

    setupCarousel(section);
  };

  initSection(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
